<template>
  <div>
    <b-container fluid>
      <b-row>
        <b-col cols="12" class="p-0">
          <TopBarMember class="mb-0 mb-sm-3" />
        </b-col>
      </b-row>
    </b-container>
    <b-container class="p-0 px-sm-3">
      <b-card
        header-bg-variant="dark"
        header-border-variant="dark"
        header-text-variant="white"
        header-tag="header"
        border-variant="dark"
        class="main-card"
        body-class="p-2"
      >
        <template #header class="card-header px-0">
          <router-link to="/">
            <i class="fas fa-chevron-left"></i> หน้าหลัก
          </router-link>
        </template>
        <b-card
          border-variant="dark"
          header-bg-variant="dark"
          header-class="p-2"
          body-class="pt-3 pb-0"
        >
          <template #header>
            <h5 class="text-white mb-0">
              <i class="fas fa-poll"></i> สรุปโพย
            </h5>
          </template>
          <b-row>
            <b-col class="px-2 mb-3" cols="12" sm="12" md="6" lg="6" xl="6">
              <b-card
                border-variant="warning"
                header-class="p-0"
                body-class="goldpattern py-0 px-1"
              >
                <template #header>
                  <div class="font-weight-bold text-center header-line">
                    <span class="mr-2">ยอดแทงวันนี้</span>
                    <b-badge variant="secondary" pill>฿</b-badge>
                  </div>
                </template>
                <h3 class="text-border-number mb-0 font-weight-bold text-center body-line">{{totalBet}}</h3>
              </b-card>
            </b-col>
            <b-col class="px-2 mb-3" cols="4" sm="4" md="2" lg="2" xl="2">
              <b-card border-variant="dark" header-class="p-0" body-class="silverpattern py-0 px-1">
                <template #header>
                  <div class="font-weight-bold text-center header-line">โพยวันนี้</div>
                </template>
                <div class="text-border-number mb-0 font-weight-bold text-center body-line">{{tickets.filter( i => [formatDate(null, 'YYYY-MM-DD')].includes( i.date )).length}}</div>
              </b-card>
            </b-col>
            <b-col class="px-2 mb-3" cols="4" sm="4" md="2" lg="2" xl="2">
              <b-card
                border-variant="warning"
                header-class="p-0"
                body-bg-variant="warning"
                body-class="py-0 px-1"
              >
                <template #header>
                  <div class="font-weight-bold text-center header-line">ออกผลแล้ว</div>
                </template>
                <div class="text-border-number mb-0 font-weight-bold text-center body-line">{{tickets.filter( i => ['2','3','4',2,3,4].includes( i.status )).filter( i => [formatDate(null, 'YYYY-MM-DD')].includes( i.date )).length}}</div>
              </b-card>
            </b-col>
            <b-col class="px-2 mb-3" cols="4" sm="4" md="2" lg="2" xl="2">
              <b-card border-variant="secondary" header-class="p-0" body-class="py-0 px-1 bg-gray">
                <template #header>
                  <div class="font-weight-bold text-center header-line">ยังไม่ออกผล</div>
                </template>
                <div class="text-border-number mb-0 font-weight-bold text-center body-line">{{tickets.filter( i => ['1', 1].includes( i.status )).filter( i => [formatDate(null, 'YYYY-MM-DD')].includes( i.date )).length}}</div>
              </b-card>
            </b-col>
          </b-row>
          <b-row>
            <b-col class="px-2 pb-3">
              <!-- <v-select
                label="title"
                :options="type"
                v-model="typeSelected"
                :clearSearchOnSelect="false"
              ></v-select> -->
            </b-col>
          </b-row>
          <b-row>
            <b-col class="px-2 pb-3">
              <ul class="nav nav-tabs nav-fill font-weight-bold">
                <li class="nav-item">
                  <a
                    :class="['nav-link', 'poylist-item', poyTabSelected == 'all' ? 'active' : '']"
                    @click="poyTabSelected = 'all'"
                    href="javascript:void()"
                    id="all-tab"
                    data-toggle="tab"
                    role="tab"
                    aria-controls="all"
                    :aria-selected="poyTabSelected == 'all'"
                  >
                    <span>โพยวันนี้</span>
                    <span>ทั้งหมด</span>
                  </a>
                </li>
                <li class="nav-item">
                  <a
                    :class="['nav-link', 'poylist-item', poyTabSelected == 'unsuccess' ? 'active' : '']"
                    href="javascript:void()"
                    @click="poyTabSelected = 'unsuccess'"
                    id="unsuccess-tab"
                    data-toggle="tab"
                    role="tab"
                    aria-controls="unsuccess"
                    :aria-selected="poyTabSelected == 'unsuccess'"
                  >
                    <span>โพยหวย</span>
                    <span>รอออกผล</span>
                  </a>
                </li>
                <li class="nav-item">
                  <a
                    :class="['nav-link', 'poylist-item', poyTabSelected == 'success' ? 'active' : '']"
                    href="javascript:void()"
                    @click="poyTabSelected = 'success'"
                    id="success-tab"
                    data-toggle="tab"
                    role="tab"
                    aria-controls="success"
                    :aria-selected="poyTabSelected == 'success'"
                  >
                    <span>โพยหวย</span>
                    <span>ผลออกแล้ว</span>
                  </a>
                </li>
                <li class="nav-item">
                  <a
                    :class="['nav-link', 'poylist-item', poyTabSelected == 'history' ? 'active' : '']"
                    href="javascript:void()"
                    @click="poyTabSelected = 'history'"
                    id="history-tab"
                    data-toggle="tab"
                    role="tab"
                    aria-controls="history"
                    :aria-selected="poyTabSelected == 'history'"
                  >
                    <span>โพยหวย</span>
                    <span>ก่อนหน้า</span>
                  </a>
                </li>
              </ul>
              <div class="tab-content" id="myTabContent">
                <div
                  :class="['tab-pane', 'fade', 'p-2', poyTabSelected == 'all' ? 'show active silverpattern' : '']"
                  id="all"
                  role="tabpanel"
                  aria-labelledby="all-tab"
                >
                  <div class="text-center text-danger" v-if="tickets.filter( i => [formatDate(null, 'YYYY-MM-DD')].includes( i.date )).length === 0">ไม่มีรายการ</div>
                  <b-container v-else>
                    <b-row>
                      <b-col
                        cols="12"
                        sm="6"
                        md="4"
                        class="px-1 mb-2"
                        v-for="item in tickets.filter( i => [formatDate(null, 'YYYY-MM-DD')].includes( i.date ))"
                        v-bind:key="item.customerPlayID"
                      >
                        <b-card
                          class="rounded-lg"
                          border-variant="dark"
                          header-bg-variant="light"
                          header-class="mb-0 p-2 d-flex align-items-stretch card-poy-header"
                          body-class="p-0 d-flex"
                          footer-class="d-flex align-items-center p-2"
                        >
                          <template #header>
                            <div class="d-flex flex-column justify-content-center">
                              <h6 class="font-weight-bold mb-0" v-if="item.lottoType == 1 || item.lottoType == 2 || item.lottoType == '1' || item.lottoType == '2'">หวยยี่กี รอบที่ {{item.roundNumber}}</h6>
                              <h6 class="font-weight-bold mb-0" v-else>{{getLottoType.filter( i => [item.lottoType].includes( i.lottoType ))[0].lottoDesc}}</h6>
                              <small>วันที่: {{ formatDate(item.pingPongDate, "DD/MM/YYYY HH:mm") }}</small>
                            </div>
                            <div class="ml-auto d-flex">
                              <div class="flex-fill poy-status unsuccess bg-warning" v-if="item.status == 1 || item.status == '1'">รอออกผล</div>
                              <div class="flex-fill poy-status unsuccess bg-success" v-if="item.status == '2' && (item.totalWon != 0)">{{item.totalWon == 0 ? 'ไม่ถูกรางวัล' : 'ถูกรางวัล'}}</div>
                              <div class="flex-fill poy-status unsuccess bg-danger" v-if="item.status == '2' && ( item.totalWon == 0)">{{item.totalWon == 0 ? 'ไม่ถูกรางวัล' : 'ถูกรางวัล'}}</div>
                              <div class="flex-fill poy-status unsuccess bg-light" v-if="item.status == 3 || item.status == '3'">ไม่ออกผล</div>
                              <div class="flex-fill poy-status unsuccess bg-light" v-if="item.status == 4 || item.status == '4'">ยกเลิก</div>
                            </div>
                          </template>
                          <div class="w-50 border-right pl-2 pb-2 pt-1">
                            <small>เงินเดิมพัน</small>
                            <h5 class="text-primary font-number my-0">
                              <span class="thb">฿ {{item.totalPaid}}</span>
                            </h5>
                          </div>
                          <div class="w-50 text-right pr-2 pb-2 pt-1">
                            <small>ผลแพ้/ชนะ</small>
                            <h5 class="text-secondary font-number my-0">
                              <span class>
                                <span class="thb">฿ {{item.totalWon == '' ? '-' : item.totalWon}}</span>
                              </span>
                            </h5>
                          </div>
                          <template #footer>
                            <small>{{ formatDate(item.createdDate, "DD/MM/YYYY HH:mm") }}</small>
                            <b-btn
                              size="sm"
                              class="ml-auto py-0"
                              variant="outline-dark"
                              :to="'/member/poy/' + item.type + '/' + item.lottoType + '/' + item.customerPlayID"
                            >
                              <!-- #{{item.customerPlayID}} -->
                              <span>
                                <i class="fas fa-search"></i> รายละเอียด #{{item.ticketNo}}
                              </span>
                            </b-btn>
                          </template>
                        </b-card>
                      </b-col>
                    </b-row>
                  </b-container>
                </div>
                <div
                  :class="['tab-pane', 'fade', 'p-2', poyTabSelected == 'unsuccess' ? 'show active silverpattern' : '']"
                  class="tab-pane fade"
                  id="unsuccess"
                  role="tabpanel"
                  aria-labelledby="unsuccess-tab"
                >
                  <div class="text-center text-danger" v-if="tickets.filter( i => ['1', 1].includes( i.status )).length === 0">ไม่มีรายการ</div>
                  <b-container v-else>
                    <b-row>
                      <b-col
                        cols="12"
                        sm="6"
                        md="4"
                        class="px-1 mb-2"
                        v-for="item in tickets.filter( i => ['1', 1].includes( i.status ))"
                        v-bind:key="item.customerPlayID"
                      >
                        <b-card
                          class="rounded-lg"
                          border-variant="dark"
                          header-bg-variant="light"
                          header-class="mb-0 p-2 d-flex align-items-stretch card-poy-header"
                          body-class="p-0 d-flex"
                          footer-class="d-flex align-items-center p-2"
                        >
                          <template #header>
                            <div class="d-flex flex-column justify-content-center">
                              <h6 class="font-weight-bold mb-0" v-if="item.lottoType == 1 || item.lottoType == 2 || item.lottoType == '1' || item.lottoType == '2'">หวยยี่กี รอบที่ {{item.roundNumber}}</h6>
                              <h6 class="font-weight-bold mb-0" v-else>{{getLottoType.filter( i => [item.lottoType].includes( i.lottoType ))[0].lottoDesc}}</h6>
                              <small>วันที่: {{ formatDate(item.pingPongDate, "DD/MM/YYYY HH:mm") }}</small>
                            </div>
                            <div class="ml-auto d-flex">
                              <div class="flex-fill poy-status unsuccess bg-warning" v-if="item.status == 1 || item.status == '1'">รอออกผล</div>
                              <div class="flex-fill poy-status unsuccess bg-success" v-if="item.status == 2 || item.status == '2'">{{item.totalWon == '' || item.totalWon == 0 || item.totalWon == '0' ? 'ไม่ถูกรางวัล' : 'ถูกรางวัล'}}</div>
                              <div class="flex-fill poy-status unsuccess bg-light" v-if="item.status == 3 || item.status == '3'">ไม่ออกผล</div>
                              <div class="flex-fill poy-status unsuccess bg-light" v-if="item.status == 4 || item.status == '4'">ยกเลิก</div>
                            </div>
                          </template>
                          <div class="w-50 border-right pl-2 pb-2 pt-1">
                            <small>เงินเดิมพัน</small>
                            <h5 class="text-primary font-number my-0">
                              <span class="thb">฿ {{item.totalPaid}}</span>
                            </h5>
                          </div>
                          <div class="w-50 text-right pr-2 pb-2 pt-1">
                            <small>ผลแพ้/ชนะ</small>
                            <h5 class="text-secondary font-number my-0">
                              <span class>
                                <span class="thb">฿ {{item.totalWon == '' ? '-' : item.totalWon}}</span>
                              </span>
                            </h5>
                          </div>
                          <template #footer>
                            <small>{{ formatDate(item.createdDate, "DD/MM/YYYY HH:mm") }}</small>
                            <b-btn
                              size="sm"
                              class="ml-auto py-0"
                              variant="outline-dark"
                              :to="'/member/poy/' + item.type + '/' + item.lottoType + '/' + item.customerPlayID"
                            >
                              <!-- #{{item.customerPlayID}} -->
                              <span>
                                <i class="fas fa-search"></i> รายละเอียด #{{item.ticketNo}}
                              </span>
                            </b-btn>
                          </template>
                        </b-card>
                      </b-col>
                    </b-row>
                  </b-container>
                </div>
                <div
                  :class="['tab-pane', 'fade', 'p-2', poyTabSelected == 'success' ? 'show active silverpattern' : '']"
                  class="tab-pane fade"
                  id="success"
                  role="tabpanel"
                  aria-labelledby="success-tab"
                >
                  <div class="text-center text-danger" v-if="tickets.filter( i => ['2','3','4',2,3,4].includes( i.status )).filter( i => [formatDate(null, 'YYYY-MM-DD')].includes( i.date )).length === 0">ไม่มีรายการ</div>
                  <b-container v-else>
                    <b-row>
                      <b-col
                        cols="12"
                        sm="6"
                        md="4"
                        class="px-1 mb-2"
                        v-for="item in tickets.filter( i => ['2','3','4',2,3,4].includes( i.status )).filter( i => [formatDate(null, 'YYYY-MM-DD')].includes( i.date ))"
                        v-bind:key="item.customerPlayID"
                      >
                        <b-card
                          class="rounded-lg"
                          border-variant="dark"
                          header-bg-variant="light"
                          header-class="mb-0 p-2 d-flex align-items-stretch card-poy-header"
                          body-class="p-0 d-flex"
                          footer-class="d-flex align-items-center p-2"
                        >
                          <template #header>
                            <div class="d-flex flex-column justify-content-center">
                              <h6 class="font-weight-bold mb-0" v-if="item.lottoType == 1 || item.lottoType == 2 || item.lottoType == '1' || item.lottoType == '2'">หวยยี่กี รอบที่ {{item.roundNumber}}</h6>
                              <h6 class="font-weight-bold mb-0" v-else>{{getLottoType.filter( i => [item.lottoType].includes( i.lottoType ))[0].lottoDesc}}</h6>
                              <small>วันที่: {{ formatDate(item.pingPongDate, "DD/MM/YYYY HH:mm") }}</small>
                            </div>
                            <div class="ml-auto d-flex">
                              <div class="flex-fill poy-status unsuccess bg-warning" v-if="item.status == 1 || item.status == '1'">รอออกผล</div>
                              <div class="flex-fill poy-status unsuccess bg-success" v-if="item.status == 2 || item.status == '2'">{{item.totalWon == '' || item.totalWon == 0 || item.totalWon == '0' ? 'ไม่ถูกรางวัล' : 'ถูกรางวัล'}}</div>
                              <div class="flex-fill poy-status unsuccess bg-light" v-if="item.status == 3 || item.status == '3'">ไม่ออกผล</div>
                              <div class="flex-fill poy-status unsuccess bg-light" v-if="item.status == 4 || item.status == '4'">ยกเลิก</div>
                            </div>
                          </template>
                          <div class="w-50 border-right pl-2 pb-2 pt-1">
                            <small>เงินเดิมพัน</small>
                            <h5 class="text-primary font-number my-0">
                              <span class="thb">฿ {{item.totalPaid}}</span>
                            </h5>
                          </div>
                          <div class="w-50 text-right pr-2 pb-2 pt-1">
                            <small>ผลแพ้/ชนะ</small>
                            <h5 class="text-secondary font-number my-0">
                              <span class>
                                <span class="thb">฿ {{item.totalWon == '' ? '-' : item.totalWon}}</span>
                              </span>
                            </h5>
                          </div>
                          <template #footer>
                            <small>{{ formatDate(item.createdDate, "DD/MM/YYYY HH:mm") }}</small>
                            <b-btn
                              size="sm"
                              class="ml-auto py-0"
                              variant="outline-dark"
                              :to="'/member/poy/' + item.type + '/' + item.lottoType + '/' + item.customerPlayID"
                            >
                              <!-- #{{item.customerPlayID}} -->
                              <span>
                                <i class="fas fa-search"></i> รายละเอียด #{{item.ticketNo}}
                              </span>
                            </b-btn>
                          </template>
                        </b-card>
                      </b-col>
                    </b-row>
                  </b-container>
                </div>
                <div
                  :class="['tab-pane', 'fade', 'p-2', poyTabSelected == 'history' ? 'show active silverpattern' : '']"
                  class="tab-pane fade"
                  id="history"
                  role="tabpanel"
                  aria-labelledby="history-tab"
                >
                  <div class="text-center text-danger" v-if="tickets.filter( i => ['2','3','4',2,3,4].includes( i.status )).filter( i => ![formatDate(null, 'YYYY-MM-DD')].includes( i.date )).length === 0">ไม่มีรายการ</div>
                  <b-container v-else>
                    <b-row>
                      <b-col
                        cols="12"
                        sm="6"
                        md="4"
                        class="px-1 mb-2"
                        v-for="item in tickets.filter( i => ['2','3','4',2,3,4].includes( i.status )).filter( i => ![formatDate(null, 'YYYY-MM-DD')].includes( i.date ))"
                        v-bind:key="item.customerPlayID"
                      >
                        <b-card
                          class="rounded-lg"
                          border-variant="dark"
                          header-bg-variant="light"
                          header-class="mb-0 p-2 d-flex align-items-stretch card-poy-header"
                          body-class="p-0 d-flex"
                          footer-class="d-flex align-items-center p-2"
                        >
                          <template #header>
                            <div class="d-flex flex-column justify-content-center">
                              <h6 class="font-weight-bold mb-0" v-if="item.lottoType == 1 || item.lottoType == 2 || item.lottoType == '1' || item.lottoType == '2'">หวยยี่กี รอบที่ {{item.roundNumber}}</h6>
                              <h6 class="font-weight-bold mb-0" v-else>{{getLottoType.filter( i => [item.lottoType].includes( i.lottoType ))[0].lottoDesc}}</h6>
                              <small>วันที่: {{ formatDate(item.pingPongDate, "DD/MM/YYYY HH:mm") }}</small>
                            </div>
                            <div class="ml-auto d-flex">
                              <div class="flex-fill poy-status unsuccess bg-warning" v-if="item.status == 1 || item.status == '1'">รอออกผล</div>
                              <div class="flex-fill poy-status unsuccess bg-success" v-else-if="item.status == 2 || item.status == '2'">{{item.totalWon == '' || item.totalWon == 0 || item.totalWon == '0' ? 'ไม่ถูกรางวัล' : 'ถูกรางวัล'}}</div>
                              <div class="flex-fill poy-status unsuccess bg-light" v-else-if="item.status == 3 || item.status == '3'">ไม่ออกผล</div>
                              <div class="flex-fill poy-status unsuccess bg-light" v-else-if="item.status == 4 || item.status == '4'">ยกเลิก</div>
                            </div>
                          </template>
                          <div class="w-50 border-right pl-2 pb-2 pt-1">
                            <small>เงินเดิมพัน</small>
                            <h5 class="text-primary font-number my-0">
                              <span class="thb">฿ {{item.totalPaid}}</span>
                            </h5>
                          </div>
                          <div class="w-50 text-right pr-2 pb-2 pt-1">
                            <small>ผลแพ้/ชนะ</small>
                            <h5 class="text-secondary font-number my-0">
                              <span class>
                                <span class="thb">฿ {{item.totalWon == '' ? '-' : item.totalWon}}</span>
                              </span>
                            </h5>
                          </div>
                          <template #footer>
                            <small>{{ formatDate(item.createdDate, "DD/MM/YYYY HH:mm") }}</small>
                            <b-btn
                              size="sm"
                              class="ml-auto py-0"
                              variant="outline-dark"
                              :to="'/member/poy/' + item.type + '/' + item.lottoType + '/' + item.customerPlayID"
                            >
                              <!-- #{{item.customerPlayID}} -->
                              <span>
                                <i class="fas fa-search"></i> รายละเอียด #{{item.ticketNo}}
                              </span>
                            </b-btn>
                          </template>
                        </b-card>
                      </b-col>
                    </b-row>
                  </b-container>
                </div>
              </div>
            </b-col>
          </b-row>
        </b-card>
      </b-card>
    </b-container>
    <FooterIndex class="mt-3" />
  </div>
</template>

<script>
import TopBarMember from "@/components/TopBarMember.vue";
import FooterIndex from "@/components/Footer.vue";
import { mapActions, mapGetters } from "vuex";
import moment from "moment";
import axios from "axios";

export default {
  name: "Poy",
  props: ['page'],
  components: {
    TopBarMember,
    FooterIndex
  },
  data() {
    return {
      tickets: [],
      totalBet: 0,
      typeSelected: {
        code: "ALL",
        title: "หวยทั้งหมด"
      },
      poyTabSelected: "all",
      type: [
        {
          code: "ALL",
          title: "หวยทั้งหมด"
        },
        {
          code: "GOV",
          title: "หายรัฐบาล"
        },
        {
          code: "STK",
          title: "หวยหุ้น"
        },
        {
          code: "VIP",
          title: "จับยี่กี VIP"
        }
      ]
    };
  },
  mounted() {
    this.getMyTicket();
    console.log('getLottoType', this.getLottoType);
  },
  methods: {
    formatDate(datetime,format) {
      if(datetime === null) {
        return moment().format(format);
      }
      else {
        return moment(String(datetime)).format(format);
      }
    },
    getMyTicket() {
      axios.post(this.getApiUrl + "/pingpong/getmyticket",
        {
          username: this.getUsername,
          lottoType: 1
        },
        {
          headers: {
            "Content-Type": "application/json",
            "token": this.getAccessToken,
            "username": this.getUsername
          }
        } )
        .then(response => {
          this.tickets = response.data.data;
          let i = 0;
          for(i = 0; i < this.tickets.length; i++) {
            this.tickets[i].date = moment(this.tickets[i].createdDate).format("YYYY-MM-DD");
            if(this.tickets[i].lottoType == 1 || this.tickets[i].lottoType == '1' || this.tickets[i].lottoType == 2 || this.tickets[i].lottoType == '2') {
              this.tickets[i].type = 'pingpong';
            }
            else if (this.tickets[i].lottoType == 26 || this.tickets[i].lottoType == '26' || this.tickets[i].lottoType == 27 || this.tickets[i].lottoType == '27' || this.tickets[i].lottoType == 28 || this.tickets[i].lottoType == '28'){
              this.tickets[i].type = 'lottoset';
            }
            else if (this.tickets[i].lottoType == 29 || this.tickets[i].lottoType == '29'){
              this.tickets[i].type = 'jackpot';
            }
            else {
              this.tickets[i].type = 'lotto';
            }
            if(this.tickets[i].date == moment().format("YYYY-MM-DD")) {
              this.totalBet = this.totalBet + parseInt(this.tickets[i].totalBet);
            }
          }
          // this.totalBet = this.tickets[0].totalBet;
          console.log('Get my ticket', this.tickets, this.tickets.length);
        });
    }
  },
  computed: {
    ...mapGetters({
      getAccessToken: "getAccessToken",
      getUsername: "getUsername",
      getCashAmount: "getCashAmount",
      getLottoType: "getLottoType",
      getApiUrl: "getApiUrl"
    })
  }
}
</script>

<style lang="scss" scoped>
.main-card {
  min-height: calc((100vh - 104px) - 49px);
}

.card-poy-header {
  border-bottom: #343a40 1px dashed;
  background-color: rgba(235, 235, 235, 0.8);
  line-height: 1;
}

.poy-status {
  width: 100%;
  border-radius: 5px;
  padding: 2px 5px;
  display: flex;
  justify-content: center;
  align-items: center;
  border: #343a40 1px solid;
  font-weight: bold;

  &.unsuccess {
    background-color: #ffc107;
    color: white;
    text-shadow: rgb(0 0 0 / 90%) 1px 1px 2px;
  }
}

.font-number {
  font-family: "Gugi", cursive;
}

.nav-tabs {
  border-color: #333;
  border-bottom: none;

  .nav-link {
    border-bottom: 1px solid #333;

    &:hover {
      border-bottom: 1px solid #333;
    }

    &.active {
      border-color: #333;
      border-bottom: none;
    }
  }
}

.poylist-item {
  color: #000;

  span:last-child {
    color: #b68800;
  }

  span {
    padding-right: 2px;
    @media screen and (max-width: 767.98px) {
      display: block;
      font-size: 85%;
    }
  }

  &.active {
    background: url(../../assets/images/silver-pattern2.jpeg) top center;
    background-size: 100%;
  }
}

.tab-pane {
  border: 1px solid #333;
  border-top: none;
}

// a.nav-link {
//   background: url(../../assets/images/silver-pattern.jpg) top center;
//   background-size: 100%;
// }

.card-header {
  font-size: 90%;
  line-height: 90%;

  a {
    color: #bbbbbb;

    &:hover {
      color: #bd841b;
      text-decoration: none;
    }
  }
}

.header-line {
  line-height: 25px;
}

.body-line {
  line-height: 40px;
  font-family: "Gugi", cursive;
}

.bg-gray {
  background-color: #d6d8db;
}

.text-border-number {
  text-shadow: #fff 2px 0px 0px, #fff 1.75517px 0.958851px 0px,
    #fff 1.0806px 1.68294px 0px, #fff 0.141474px 1.99499px 0px,
    #fff -0.832294px 1.81859px 0px, #fff -1.60229px 1.19694px 0px,
    #fff -1.97998px 0.28224px 0px, #fff -1.87291px -0.701566px 0px,
    #fff -1.30729px -1.5136px 0px, #fff -0.421592px -1.95506px 0px,
    #fff 0.567324px -1.91785px 0px, #fff 1.41734px -1.41108px 0px,
    #fff 1.92034px -0.558831px 0px;
  letter-spacing: 0.04em;
}

h5 {
  color: #bd841b;
  font-weight: bold;
}

.goldpattern {
  background-size: 100%;
  background: url(../../assets/images/gold-pattern.jpg) top center;
}

.silverpattern {
  background: url(../../assets/images/silver-pattern.jpg) top center;
  background-size: 100%;
}

.credit-balance {
  background-color: #d4edda !important;
  border-color: #c3e6cb;
  font-size: 30px;
  line-height: 40px;
  height: 48px;

  :focus {
    outline: none;
  }
}
</style>